import { AsyncPipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDrawerModule, NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzSwitchModule } from 'ng-zorro-antd/switch';

import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';

import { AlertsActionsComponent } from '@app/alerts/components/actions/alerts-actions.component';
import { AlertsComponent } from '@app/alerts/components/alerts.component';
import { AlertsInfoComponent } from '@app/alerts/components/info/alerts-info.component';
import { AlertsMoreActionsComponent } from '@app/alerts/components/more-actions/alerts-more-actions.component';
import { AlertsNoDataComponent } from '@app/alerts/components/no-data/alerts-no-data.component';
import { AlertsResolvedToggleComponent } from '@app/alerts/components/resolved-toggle/alerts-resolved-toggle.component';
import { AlertsSeverityIconComponent } from '@app/alerts/components/severity-icon/alerts-severity-icon.component';
import { AlertsStatusLabelComponent } from '@app/alerts/components/status-label/alerts-status-label.component';
import { SpinnerOverlayComponent } from '@app/shared/modules/spinner-overlay/spinner-overlay.component';
import { SharedDirectivesModule } from '@app/shared/shared-directives.module';

@Component({
  selector: 'adspt-alerts-center-drawer',
  templateUrl: './alerts-center-drawer.component.html',
  styleUrls: ['./alerts-center-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: AlertsComponent, useExisting: AlertsCenterDrawerComponent }],
  imports: [
    FormsModule,
    RouterLink,
    NgIf,
    AsyncPipe,
    NgClass,
    NgForOf,
    NzDrawerModule,
    NzSwitchModule,
    NzButtonModule,
    NzDividerModule,
    TranslateModule,
    forwardRef(() => SharedDirectivesModule),
    SpinnerOverlayComponent,
    AlertsSeverityIconComponent,
    AlertsStatusLabelComponent,
    AlertsMoreActionsComponent,
    AlertsInfoComponent,
    AlertsActionsComponent,
    AlertsResolvedToggleComponent,
    AlertsNoDataComponent,
  ],
})
export class AlertsCenterDrawerComponent extends AlertsComponent {
  readonly alertSource = 'drawer';

  constructor(
    readonly drawerRef: NzDrawerRef<void>,
    store: Store,
  ) {
    super(store);
    super.onInit();
  }
}
